/* eslint max-len: 0 */
/* istanbul ignore file */

import { CookbookFilterConfig } from '../../types/CookbookConfigs';

export const generateMockPromise = async <ReturnedValue>(response: ReturnedValue): Promise<ReturnedValue> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(response);
    }, 300);
  });
};

export const TRANSFORMATIONS_FILTER_PRESET = { inPresets: { recipesCount: 10 }, notInPresets: { recipesCount: 8 } };

export const TRANSFORMATIONS_FILTER_STRICT = {
  allowedForStrict: {
    recipesCount: 7,
  },
  notAllowedForStrict: {
    recipesCount: 11,
  },
};

export const COOKBOOK_FILTER_COMPLEXITY: CookbookFilterConfig['complexity'] = {
  advanced: {
    complexity: 'advanced',
    recipesCount: 20,
  },
  beginner: {
    complexity: 'beginner',
    recipesCount: 12,
  },
  intermediate: {
    complexity: 'intermediate',
    recipesCount: 18,
  },
};

export const COOKBOOK_FILTER_CATEGORIES: CookbookFilterConfig['categories'] = [
  'Filters And effects',
  'Presentation',
  'Video',
  'Photography',
  'Cropping',
  'Layers',
  'Social apps',
  'Marketing',
  'Creative',
  'Email Marketing',
  'Media Acceleration',
  'Code',
  'Watermarking',
  'Visual Merchandising',
  'SEO',
  'Advertising',
  'Printing',
  'Personalization',
  'Background Removal',
].map((name, i) => ({
  id: i,
  name,
  recipesCount: Math.floor(((35634564 / (i + 1)) % 100) / 4), // seed from 1 to 25
}));
